// COMPONENT
import HeaderComponent from "../../components/Header";
import MenuComponent from "../../components/SideMenu";
import BreadcrumbComponent from "../../components/Breadcrumb";

// LIBRARY
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import ReactLoading from "react-loading";
import React, { Component } from "react";
import Pagination from "react-js-pagination";
import { Slide } from "react-slideshow-image";
import DateRangePicker from "react-bootstrap-daterangepicker";

// CSS
import "../../components/css/style.css";
import "../../components/css/bootstrap.css";
import "react-slideshow-image/dist/styles.css";
import "bootstrap-daterangepicker/daterangepicker.css";

const cookies = new Cookies();
toast.configure();

let month_array = [
  "",
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];
export default class InAndOutListScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: cookies.get("token") ? "token " + cookies.get("token") : "",

      filter_project: "",

      project:
        cookies.get("user_profile").agency_list &&
        cookies.get("user_profile").agency_list
          ? cookies.get("user_profile").agency_list
          : null,

      page: 1,

      data: []
    };
  }
  componentDidMount() {
    this.GET();
    var user = cookies.get("user_profile");
    if (user.role_data.role_name === "system_admin") {
      this.get_Project();
    } else {
      this.setState(prev => {
  const profile = cookies.get("user_profile");

  // ถ้ามี project_id นี้แล้ว → ไม่เพิ่ม
  if (prev.project.some(p => p.project_id === profile.project_id)) {
    return null; // ไม่เปลี่ยน state
  }

  return {
    project: [
      ...prev.project,
      {
        agency_id: profile.agency_id,
        agency_name: profile.agency_name,
        project_id: profile.project_id,
        project_name: profile.project_name,
      },
    ],
  };
});
    }
  }

  get_Project() {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
    };
    fetch(global.api + "v1/project/all", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ project: result.data.data });
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ project: [] });
              break;
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ");
              cookies.remove("token");
              window.location.href = "/";
              break;
          }
        }
      })
      .catch((e) => {});
  }

  async GET() {
    this.setState({ loading: true });

    try {
      const headers = {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      };

      // 0. ดึง notify
      // page แรก
      const res = await fetch(`${global.api}v1/call-service/notify?page=1`, { headers });
      const result_notify = await res.json();

      let notify = [...result_notify.data.data];
      const totalPages = result_notify.data.page_number;

      // สร้าง request สำหรับหน้าที่เหลือ
      const requests = [];
      for (let i = 2; i <= totalPages; i++) {
        requests.push(fetch(`${global.api}v1/call-service/notify?page=${i}`, { headers }).then(r => r.json()).then(j => j.data.data));
      }

      // ยิงพร้อมกัน
      const results_notify = await Promise.all(requests);

      // รวมข้อมูล
      notify.push(...results_notify.flat());

      // 1. ดึง project ทั้งหมด
      var user = cookies.get("user_profile");
      let result = null;
      if(user.role_data.role_name === "system_admin"){
        const res = await fetch(global.api + "v1/project/all", { method: "GET", headers });
        result = await res.json();
      }

      const projects = result?.data?.data || this.state.project;
      const batchSize = 10;
      
      // 2. ยิงทีละ 10
      for (let i = 0; i < projects.length; i += batchSize) {
        const batch = projects.slice(i, i + batchSize);

        const batchResult = await Promise.all(
          batch.map(async (p) => {
            const r = await fetch(global.api + "v1/project/agency", {
              method: "POST",
              headers,
              body: JSON.stringify({
                project_id: p.project_id,
              }),
            });

            const json = await r.json();

            return {
              project_id: p.project_id, // ✅ ใส่ project_id
              project_name: p.project_name, // ✅ ใส่ project_name
              chat_id: "",
              is_change: false,
              ...json?.data?.data?.[0],
              ...notify?.find(
                (d) => d.agency_id === json?.data?.data?.[0]?.agency_id,
              ),
            };
          }),
        );

        this.setState({
        data: [...this.state.data,...batchResult],
        loading: false,
      });
      }

      
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  }

  Submit = async () => {
    const { data } = this.state;

    const headers = {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: this.state.token,
    };

    const bot_token = global.bot_token;
    const batchSize = 10;

    const changeList = data.filter((e) => e.is_change);
    console.log("changeList:",changeList)

    try {
      for (let i = 0; i < changeList.length; i += batchSize) {
        const batch = changeList.slice(i, i + batchSize);

        await Promise.all(
          batch.map((item) => {
            const method = item.uid ? "PUT" : "POST";
            const url = item.uid ? `${global.api}v1/call-service/notify/update` : `${global.api}v1/call-service/notify/create`;

            return fetch(url, {
              method,
              headers,
              body: JSON.stringify({
                uid: item.uid,
                agency_id: item.agency_id,
                bot_token,
                chat_id: item.chat_id,
              }),
            });
          }),
        );
      }
       this.alert("success", "สำเร็จ", "ทำรายการบันทึกข้อมูลสำเร็จ")
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  alert(icon, title, detail) {
    Swal.fire({
      icon: icon,
      title: title,
      text: detail,
      confirmButtonText: "ตกลง",
    });
  }

  clear_form() {
    this.setState({
      loading: false,
    });
  }

  render() {
    return (
      <div className="full bg-contain">
        {this.state.loading && (
          <div className="loading">
            <ReactLoading
              type={"spinningBubbles"}
              color="#fff"
              height={48}
              width={48}
            />
          </div>
        )}
        <div className="menu-container ">
          <MenuComponent />

          <div className="w-100 position-relative">
            <BreadcrumbComponent page1="บริการ" page2="ตั้งค่าแจ้งเตือน" />
            <HeaderComponent header="ตั้งค่าแจ้งเตือน" report="false" />

            {/* เมนู ฟิลเตอร์  */}
            <div className="bg-gray px-3 pt-3 w-100">
              <div className="row d-flex mx-0 justify-content-between">
                {/* ตัวกรองโครงการ */}
                <div className="mx-2 mb-3">
                  <select
                    className="form-control"
                    value={this.state.filter_project}
                    onChange={(e) => {
                      this.setState({
                        filter_project: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected disabled>
                      -- เลือกโครงการ --
                    </option>
                    {this.state.project &&
                      this.state.project.map((item, index) => (
                        <option value={item.project_id} key={index}>
                          {item.project_name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            {/* ตาราง */}
            <div className="w-100 p-3" style={{ marginBottom: 100 }}>
              <div className="table-responsive">
                <table className="table design-table">
                  <thead>
                    <tr>
                      <th className="text-left w-150px">ชื่อโครงการ</th>
                      <th className="text-left w-150px">หน่วยงาน</th>
                      <th className="text-left w-150px">telegram Chat ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data?.filter(e=> !this.state.filter_project || e.project_id === this.state.filter_project).map((item, index) => (
                      <tr key={index}>
                        <td className={item.chat_id ? "bg-light" : ""}>
                          {item.project_name}
                        </td>
                        <td className={item.chat_id ? "bg-light" : ""}>
                          {item.agency_name}
                        </td>
                        <td className={item.chat_id ? "bg-light p-0" : "p-0"}>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="telegram Chat ID"
                            onChange={(e) => {
                              let _data = this.state.data;
                              _data[index].chat_id = e.target.value;
                              _data[index].is_change = true;
                              this.setState({ data: _data });
                            }}
                            value={item.chat_id}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="position-fixed w-100 bg-light py-2 px-4 d-flex justify-content-end" style={{bottom: 0, left: 0}}>
                    <button className="btn btn-primary px-4" onClick={() => {this.Submit()}}>บันทึก</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
